import { render } from "./PartCard.vue?vue&type=template&id=f7451292&scoped=true&ts=true&lang=pug"
import script from "./PartCard.vue?vue&type=script&lang=ts"
export * from "./PartCard.vue?vue&type=script&lang=ts"

import "./PartCard.vue?vue&type=style&index=0&id=f7451292&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7451292"]])

export default __exports__